import useGoBack from "src/hook/useGoBackInventory";
import FillSamplingResultTable from "./components/FillSamplingResultTable";
import { excelStore } from "src/stores/excel-store.interface";
import { useShallow } from "zustand/react/shallow";
import { useEffect } from "react";

const FillSamplingResult = () => {
  const currentYear = new Date().getFullYear();
  const setSelectedYearExcel = excelStore(useShallow((state) => state.setSelectedYear));

  useEffect(() => {
    return () => {
      setSelectedYearExcel(currentYear.toString());
    };
  }, []);
  useGoBack();

  return <FillSamplingResultTable />;
};

export default FillSamplingResult;
